import { api } from '../serverClient';

export async function getHallOfFame() {
  return api.get('/hall-of-fame');
}
